var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7788 7.17132L17.7681 3.20579C17.7036 3.14058 17.6269 3.08882 17.5423 3.0535C17.4578 3.01818 17.3671 3 17.2755 3C17.1839 3 17.0932 3.01818 17.0086 3.0535C16.9241 3.08882 16.8473 3.14058 16.7828 3.20579L13.924 6.0721L5.11172 14.9076C5.04331 14.979 4.99121 15.0644 4.95907 15.158L3.03008 21.0855C2.99296 21.209 2.99014 21.3404 3.02193 21.4654C3.05372 21.5904 3.11891 21.7044 3.21049 21.7951C3.34084 21.9211 3.51515 21.991 3.6962 21.9899C3.76494 22.0034 3.83563 22.0034 3.90437 21.9899L9.83012 20.0836C9.92854 20.0468 10.0183 19.9899 10.0938 19.9167L21.7649 8.21488C21.8377 8.14939 21.8962 8.06948 21.9366 7.9802C21.9771 7.89092 21.9986 7.7942 21.9999 7.69615C22.0012 7.59809 21.9823 7.50083 21.9442 7.4105C21.9061 7.32017 21.8498 7.23873 21.7788 7.17132ZM9.60808 18.4279L6.58275 15.3946L14.4236 7.547L17.4489 10.5803L9.60808 18.4279ZM5.91663 16.6886L8.31746 19.0957L4.79254 20.2228L5.91663 16.6886ZM18.4065 9.59238L15.3951 6.5591L17.2824 4.68069L20.3077 7.71397L18.4065 9.59238Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPen);
export default __webpack_public_path__ + "static/media/edit-pen.809f25706ebf1514c643e25208776432.svg";
export { ForwardRef as ReactComponent };